import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { UnderwriterTitle, ViewInfoButton } from '../TableTitles/index';
import { DIALOG_TEXT, DIALOG_TITLES, PACKAGE_TYPE_UNDERWRITER } from '../../constants/packageTypes';
import TablesPropTypes from '../../propTypes/tables';
import {
    doUnderwriterPackagesHaveFilters,
    getUnderwriterPackagesContext,
    getUnderwriterPackagesForTable,
} from '../../selectors/packages';
import BrowseByType from '../BrowseByType';
import ApiPropTypes from '../../propTypes/api';

class BrowseUnderwriterPackages extends React.Component {
    state = {
        infoDialogOpen: false,
    };

    onClickViewInfoButton = () => {
        this.setState({ infoDialogOpen: true });
    };

    onCloseInfoDialog = () => {
        this.setState({ infoDialogOpen: false });
    };

    render () {
        const { infoDialogOpen } = this.state;
        const ViewInfoButtonUnderwriter = (
            <ViewInfoButton
                onClick={this.onClickViewInfoButton}
                infoDialogOpen={infoDialogOpen}
                onCloseInfoDialog={this.onCloseInfoDialog}
                dialogTitle={DIALOG_TITLES[PACKAGE_TYPE_UNDERWRITER]}
                dialogText={DIALOG_TEXT[PACKAGE_TYPE_UNDERWRITER]}
            />);
        return (
            <BrowseByType
                type={PACKAGE_TYPE_UNDERWRITER}
                title={<UnderwriterTitle button={ViewInfoButtonUnderwriter} />}
                {...this.props}
            />
        );
    }
}

BrowseUnderwriterPackages.propTypes = {
    tableData: TablesPropTypes.tablePageData.isRequired,
    tableContext: ApiPropTypes.apiPageContext.isRequired,
    hasFilters: PropTypes.bool.isRequired,
};

const mapStateToProps = function (state) {
    return {
        tableData: getUnderwriterPackagesForTable(state),
        tableContext: getUnderwriterPackagesContext(state),
        hasFilters: doUnderwriterPackagesHaveFilters(state),
    };
};

export default connect(mapStateToProps)(BrowseUnderwriterPackages);
